const naEndPoint = "/tennis/api/MemberAssociationApi/GetNationalAssociations";
const raEndPoint = "/tennis/api/MemberAssociationApi/GetRegionalAssociations";
const associationEndPoint =
  "/tennis/api/MemberAssociationApi/GetMemberAssociationById?";
const allAssociationEndPoint =
  "/tennis/api/MemberAssociationApi/GetAllNationalAssociations";

export async function getNationalAssociations() {
  const response = await fetch(`${process.env.HOST}${naEndPoint}`);
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getRegionalAssociations() {
  const response = await fetch(`${process.env.HOST}${raEndPoint}`);
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getAssociationData(id: string) {
  const response = await fetch(
    `${process.env.HOST}${associationEndPoint}id=${id}`
  );
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}

export async function getAllAssociationsData() {
  const response = await fetch(`${process.env.HOST}${allAssociationEndPoint}`);
  if (response.ok) {
    return await response.json();
  } else {
    throw Error(response.statusText);
  }
}
